const PersonSchema = (name = '', image = '') =>
  JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Person',
    name,
    image,
  });

export default PersonSchema;
